/* Native dialogs and editable gallery. Forms submit directly to Shopify. */
(() => {
  const focusOrigins = new WeakMap();
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function openDialog(dialog, trigger) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (dialog.open) return true;
    const drawer = trigger?.closest('header-drawer');
    const drawerToggle = drawer?.querySelector('summary');
    if (drawerToggle && typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer(new Event('hxy:open-dialog'), drawerToggle);
      drawerToggle.setAttribute('aria-expanded', 'false');
    }
    focusOrigins.set(dialog, drawerToggle || trigger || document.activeElement);
    if (dialog.id === 'HxySupport') {
      const subject = dialog.querySelector('[name="contact[Anliegen]"]');
      if (subject) subject.value = trigger?.matches('[data-hxy-restock]') ? 'Verfügbarkeitsanfrage' : 'Support';
      dialog.querySelector('[data-hxy-variant-field]')?.remove();
      if (trigger?.dataset.hxyVariantId) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'contact[Variante]';
        input.value = `${trigger.dataset.hxyVariantTitle || ''} (ID ${trigger.dataset.hxyVariantId})`;
        input.dataset.hxyVariantField = '';
        dialog.querySelector('form')?.append(input);
      }
    }
    dialog.showModal();
    document.body.classList.add('hxy-dialog-open');
    return true;
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-hxy-open]');
    if (opener && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const dialog = document.getElementById(opener.dataset.hxyOpen);
      if (openDialog(dialog, opener)) event.preventDefault();
      return;
    }
    const closer = event.target.closest('[data-hxy-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.matches('dialog.hxy-dialog[open]')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
        event.target.close();
      }
    }
  });
  // Capture: the native close event does not bubble.
  document.addEventListener('close', (event) => {
    if (!document.querySelector('dialog.hxy-dialog[open]')) document.body.classList.remove('hxy-dialog-open');
    const origin = focusOrigins.get(event.target);
    if (origin?.isConnected) origin.focus({ preventScroll: true });
  }, true);

  function revealFormResult() {
    let targetId;
    try { targetId = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    const target = targetId ? document.getElementById(targetId) : null;
    const dialog = target?.closest('dialog.hxy-dialog');
    if (dialog && target.querySelector('.hxy-form-result')) openDialog(dialog);
  }
  window.addEventListener('hashchange', revealFormResult);
  revealFormResult();

  const setAnnouncementHeight = () => {
    const announcement = document.querySelector('.hxy-announcement');
    document.documentElement.style.setProperty('--hxy-announcement-height', `${announcement?.offsetHeight || 0}px`);
  };
  let announcementObserver;
  function observeAnnouncement() {
    announcementObserver?.disconnect();
    if ('ResizeObserver' in window) {
      announcementObserver = new ResizeObserver(setAnnouncementHeight);
      const announcement = document.querySelector('.hxy-announcement');
      if (announcement) announcementObserver.observe(announcement);
    }
    setAnnouncementHeight();
  }
  observeAnnouncement();
  window.addEventListener('resize', setAnnouncementHeight, { passive: true });
  document.addEventListener('shopify:section:load', observeAnnouncement);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(observeAnnouncement));

  class HxyGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hxy-gallery__track');
      if (!this.track) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('[data-hxy-slide]').forEach((button) => {
        button.addEventListener('click', () => this.move(Number(button.dataset.hxySlide)), options);
      });
      this.track.addEventListener('scroll', () => this.updateButtons(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.updateButtons());
        this.observer.observe(this.track);
      }
      this.addEventListener('shopify:block:select', (event) => {
        event.target.closest('.hxy-social__tile')?.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
      }, options);
      this.updateButtons();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
    move(direction) {
      const tile = this.track.firstElementChild;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * ((tile?.getBoundingClientRect().width || this.track.clientWidth) + gap), behavior: reducedMotion() ? 'auto' : 'smooth' });
    }
    updateButtons() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const left = this.track.scrollLeft;
      const previous = this.querySelector('[data-hxy-slide="-1"]');
      const next = this.querySelector('[data-hxy-slide="1"]');
      if (previous) previous.disabled = left <= 2;
      if (next) next.disabled = left >= max - 2;
    }
  }
  if (!customElements.get('hxy-gallery')) customElements.define('hxy-gallery', HxyGallery);

  // Dawn publishes the real selected variant after its section response arrives.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      document.querySelectorAll('[data-hxy-restock]').forEach((link) => {
        if (link.closest('product-info')?.dataset.section !== data.sectionId) return;
        link.hidden = !data.variant || data.variant.available;
        link.dataset.hxyVariantId = data.variant?.id || '';
        link.dataset.hxyVariantTitle = data.variant?.title || '';
      });
    });
  }
})();
